<template>
    <input :value="value" type="number" class="form-control" @input="onInput" />
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: false,
            default: 0
        }
    },

    methods: {
        onInput($e) {
            this.$emit('input', parseInt($e.target.value));
        }
    }
};
</script>
